{
  "title": "FAQ",
  "accordion": [
    {
      "title": "Comment publier une offre d'emploi ?",
      "items": [
        {
          "answer": "Vous pouvez publier une offre d'emploi en remplissant vous-même tous les champs du formulaire de création, ou en choisissant l'un des modèles proposés. Après avoir sélectionné un modèle, vous aurez la possibilité de modifier les informations préremplies afin de les adapter à vos besoins."
        }
      ]
    },
    {
      "title": "Quand l'offre devient-elle accessible aux demandeurs d'emploi ?",
      "items": [
        {
          "answer": "Une offre est accessible aux demandeurs d'emploi lorsqu'elle est au statut « Recrutement en cours » et que le profil du demandeur correspond aux critères exigés. Les offres avec les statuts « Recrutement suspendu », « Recrutement annulé » ou « Recrutement terminé » ne seront pas proposées aux demandeurs d'emploi."
        }
      ]
    },
    {
      "title": "Que signifient les différents statuts de l'offre ?",
      "items": [
        {
          "list": [
            "Le statut « Recrutement en cours » signifie que l'offre est ouverte et que la recherche de demandeurs d'emploi est active.",
            "Le statut « Recrutement suspendu » signifie que le processus de recrutement est temporairement interrompu. Vous pourrez changer le statut ultérieurement pour relancer la recherche.",
            "Le statut « Recrutement annulé » signifie que l'entreprise a décidé d'arrêter définitivement la recherche pour ce poste. Dans ce cas, la reprise du recrutement n'est pas possible.",
            "Le statut « Recrutement terminé » signifie qu'un demandeur d'emploi a été recruté avec succès et que l'offre est clôturée. Il n'est pas possible de rouvrir une offre avec ce statut."
          ],
          "additional": "Pour consulter l'historique des changements de statut d'une offre, ouvrez la page détaillée de l'offre et cliquez sur le bouton « Activité de l'offre »."
        }
      ]
    },
    {
      "title": "Quelle est la durée de validité d'une offre publiée ?",
      "items": [
        {
          "answer": "Lors de la création de l'offre, vous définissez une période de validité (de telle date à telle date). Si, à la date de fin, aucun demandeur d'emploi n'a été recruté, l'offre est automatiquement déplacée dans les archives et n'est plus proposée.",
          "additional": "En cas de suspension puis de reprise du recrutement, la date de reprise est considérée comme la nouvelle date de début. Aucune date de fin n'est automatiquement fixée : dans ce cas, l'offre reste active sans limite jusqu'à ce que vous changiez son statut en « réussi » ou « échoué », ou que vous indiquiez manuellement une date de fin."
        }
      ]
    },
    {
      "title": "Comment ajouter un employé à l'entreprise ?",
      "items": [
        {
          "answer": "Pour ajouter un nouveau employé, rendez-vous dans la section « Employés », cliquez sur le bouton « Ajouter un employé » et remplissez tous les champs du formulaire. Un lien d'accès sera ensuite envoyé à l'adresse électronique indiquée."
        }
      ]
    },
    {
      "title": "Comment supprimer un employé ?",
      "items": [
        {
          "answer": "La suppression d'un employé se fait depuis sa page détaillée. Cliquez sur le bouton « Supprimer le employé » et confirmez l'opération. Une fois supprimé, le employé ne pourra plus accéder à son espace personnel. Toutes les offres qui lui étaient assignées seront automatiquement transférées au Manager de l'entreprise."
        }
      ]
    },
    {
      "title": "Comment supprimer l'entreprise ?",
      "items": [
        {
          "answer": "Seul le Manager de l'entreprise a la possibilité de supprimer l'entreprise. Pour cela, rendez-vous sur la page détaillée de l'entreprise et cliquez sur le bouton « Supprimer l'entreprise ». Après suppression:",
          "list": [
            "tous les employés seront désactivés,",
            "l'accès aux espaces personnels du Manager et des employés sera bloqué,",
            "toutes les offres de l'entreprise seront désactivées et ne seront plus proposées aux demandeurs d'emploi."
          ]
        }
      ]
    },
    {
      "title": "Forfait de sélection des candidats",
      "items": [
        {
          "question": "Qu'est-ce que le forfait d'une offre d'emploi ?",
          "paragraphs": [
            "Le forfait d'une offre d'emploi est une fonctionnalité de la plateforme qui sert à sélectionner des candidats pour un poste.",
            "Ses conditions définissent le mode de sélection des candidats ainsi que la manière d'interagir avec eux.",
            "Vous pouvez consulter le détail de ces conditions sur la page détaillée de l'offre, dans la section correspondante.",
            "Actuellement, le forfait principal est « Swipe ».",
            "Il vous permet de consulter les informations essentielles d'un candidat et de prendre vous-même la décision d'embauche."
          ]
        },
        {
          "question": "Comment sélectionner un candidat avec « Swipe » ?",
          "paragraphs": [
            "Ouvrez la page de l'offre d'emploi, puis, dans la section « Candidats sélectionnés », cliquez sur le bouton « Rechercher ».",
            "Une section s'ouvre alors avec les fiches des candidats que Synthia a sélectionnés pour cette offre.",
            "Les boutons « Sélectionner » et « Refuser » vous permettent d'indiquer votre décision concernant chaque candidat.",
            "Après un refus, ce candidat n'apparaîtra plus dans les recommandations pour l'offre choisie.",
            "Après avoir validé un candidat, son numéro de téléphone complet devient accessible afin que vous puissiez le contacter."
          ]
        },
        {
          "question": "Que faire s'il n'y a aucune recommandation de candidats?",
          "paragraphs": [
            "Si, après avoir parcouru la liste des candidats, vous n'en avez validé aucun, vous pouvez demander à Synthia une nouvelle sélection en cliquant sur le bouton « Rechercher ».",
            "Après une nouvelle analyse de la base de candidats, la liste se remplira de nouveaux profils.",
            "Si aucun candidat ne correspond au moment de votre demande, un message vous en informera et vous pourrez renvoyer votre demande un peu plus tard."
          ]
        }
      ]
    },
    {
      "title": "Synthia pour les employeurs",
      "items": [
        {
          "question": "Comment Synthia peut-elle aider à trouver des employés ?",
          "paragraphs": [
            "Avec Synthia, vous pouvez créer une nouvelle offre d'emploi simplement en indiquant la description du poste et les exigences attendues du candidat.",
            "Pour cela, sur la page de la liste des offres, cliquez sur le bouton « Créer », puis choisissez « Générer une offre ».",
            "Dans la fenêtre qui s'ouvre, saisissez librement toutes les informations que vous jugez utiles, puis cliquez sur « Générer ».",
            "Une fois le traitement terminé, vous serez redirigé vers la page de création de l'offre, où Synthia remplira tous les champs du formulaire pour lesquels le contexte est suffisant.",
            "Vous pourrez ensuite corriger manuellement les valeurs des champs, puis finaliser la création de l'offre."
          ]
        },
        {
          "question": "Que peut faire Synthia d'autre ?",
          "paragraphs": [
            "Dans la rubrique « Dialogue avec Synthia », vous pouvez poser toutes vos questions sur les offres d'emploi, les conditions de travail, les secteurs d'activité et tout autre sujet susceptible de vous aider à créer vos offres et à sélectionner les employés correspondants.",
            "Vous pouvez envoyer des messages vocaux à Synthia : ils seront transcrits et également affichés sous forme de texte pour faciliter l'échange."
          ]
        },
        {
          "question": "Je ne sais pas quel secteur d'activité indiquer pour l'offre.",
          "paragraphs": [
            "Sur la page de création ou de modification de l'offre, activez l'option « Sélection automatique du secteur d'activité » et Synthia vous aidera à remplir ce champ.",
            "Pour cela, elle s'appuiera sur le contexte du titre et de la description de l'offre, ainsi que sur les exigences attendues des candidats."
          ]
        }
      ]
    },
    {
      "title": "Copie d'une offre d'emploi",
      "items": [
        {
          "question": "Est-il possible de copier des offres existantes, actives ou clôturées ?",
          "paragraphs": [
            "Oui, vous pouvez créer une copie d'une offre en cliquant sur le bouton d'action correspondant dans la liste générale des offres de votre entreprise.",
            "Un formulaire de création d'une nouvelle offre s'ouvre alors, avec les champs déjà remplis à partir des données de l'offre d'origine.",
            "Tous les champs restent modifiables : vous pouvez créer une copie exacte ou créer une nouvelle offre avec des données différentes."
          ]
        },
        {
          "question": "Les candidats sélectionnés pour l'offre d'origine seront-ils transférés dans la copie ?",
          "paragraphs": [
            "Non, les candidats sélectionnés ou validés ne seront pas transférés dans la copie.",
            "Il s'agira d'une offre entièrement nouvelle, pour laquelle les candidats seront sélectionnés de nouveau, même si aucune modification n'a été apportée aux conditions de l'offre."
          ]
        }
      ]
    }
  ]
}
